import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { entityWithNameSchema } from '../types';

export type GetCashiersAllQueryParams = number[];

export const createGetCashiersAllQuery = () =>
	createAuthQuery({
		params: declareParams<GetCashiersAllQueryParams>(),
		request: {
			method: 'GET',
			url: '/account/cashiers/all',
			query: (ids) => (ids.length > 0 ? { accountIds: ids.map(String) } : {}),
		},
		response: {
			contract: zodContract(entityWithNameSchema.array()),
		},
	});
